(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jb-verlobung"] && !Shopify.designMode) return;
  try {
    
(function () {
  function track(name, way, page) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, jb_seite: page, jb_kontaktweg: way });
  }
  function init(root) {
    if (!root || root.dataset.jbvReady) return;
    root.dataset.jbvReady = '1';
    var answers = { form: '', color: '', budget: '' };
    var labels = { form: '', color: '', budget: '' };

    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-jb-contact]');
      if (link && root.contains(link)) {
        track('jb_verlobung_kontakt', link.getAttribute('data-jb-contact'), 'verlobung');
        try { sessionStorage.setItem('jbv_pop_seen', '1'); } catch (err) {}
      }
    });

    root.querySelectorAll('[data-jbv-slider]').forEach(function (slider) {
      var track = slider.querySelector('[data-jbv-track]');
      function step(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' }); }
      var p = slider.querySelector('[data-jbv-prev]'), n = slider.querySelector('[data-jbv-next]');
      if (p) p.addEventListener('click', function () { step(-1); });
      if (n) n.addEventListener('click', function () { step(1); });
    });

    var finder = root.querySelector('[data-jbv-finder]');
    if (finder) {
      var current = 0;
      function show(stepIndex, focus) {
        current = stepIndex;
        finder.querySelectorAll('[data-jbv-step]').forEach(function (p) { p.hidden = Number(p.getAttribute('data-jbv-step')) !== stepIndex; });
        finder.querySelectorAll('[data-jbv-progress]').forEach(function (li) {
          var i = Number(li.getAttribute('data-jbv-progress'));
          if (i === stepIndex) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
          li.classList.toggle('is-done', i < stepIndex);
        });
        finder.querySelector('[data-jbv-back]').hidden = stepIndex === 0;
        finder.querySelector('[data-jbv-reset]').hidden = stepIndex === 0;
        if (focus !== false) { var h = finder.querySelector('[data-jbv-step="' + stepIndex + '"] h3'); if (h) h.focus({ preventScroll: true }); }
      }
      function filter() {
        var range = answers.budget && answers.budget !== 'offen' ? answers.budget.split('-').map(Number) : null;
        var shown = 0;
        finder.querySelectorAll('[data-jbv-results] [data-form]').forEach(function (card) {
          var ok = (!answers.form || answers.form === 'offen' || card.dataset.form === answers.form) &&
                   (!answers.color || answers.color === 'offen' || card.dataset.color === answers.color || card.dataset.color === 'unbekannt') &&
                   (!range || (Number(card.dataset.price) >= range[0] && Number(card.dataset.price) <= range[1]));
          card.hidden = !(ok && shown < 6);
          if (ok && shown < 6) shown++;
        });
        finder.querySelector('[data-jbv-empty]').hidden = shown > 0;
      }
      function sync() {
        root.querySelectorAll('[data-jbv-input]').forEach(function (input) {
          var k = input.getAttribute('data-jbv-input');
          input.value = labels[k]; input.disabled = !labels[k];
        });
        var sel = root.querySelector('[data-jbv-selection]');
        if (sel) {
          var parts = [labels.form, labels.color, labels.budget].filter(Boolean);
          sel.textContent = parts.length ? 'Ihre Auswahl: ' + parts.join(' · ') : '';
          sel.hidden = !parts.length;
        }
      }
      finder.querySelectorAll('[data-jbv-key]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var k = btn.getAttribute('data-jbv-key');
          answers[k] = btn.getAttribute('data-jbv-value');
          labels[k] = btn.querySelector('span').textContent.trim();
          finder.querySelectorAll('[data-jbv-key="' + k + '"]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
          sync();
          if (current === 2) filter();
          show(Math.min(current + 1, 3));
        });
      });
      finder.querySelector('[data-jbv-back]').addEventListener('click', function () { show(Math.max(0, current - 1)); });
      finder.querySelector('[data-jbv-reset]').addEventListener('click', function () {
        answers = { form: '', color: '', budget: '' }; labels = { form: '', color: '', budget: '' };
        finder.querySelectorAll('[data-jbv-key]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        sync(); show(0);
      });
      var transfer = finder.querySelector('[data-jbv-transfer]');
      if (transfer) transfer.addEventListener('click', function () {
        var name = root.querySelector('[data-jbv-name]');
        if (name) setTimeout(function () { name.focus({ preventScroll: true }); }, 400);
      });
    }

    // Terminwahl: Wunschtag + Wunschzeit, wird als Text ins Formular übernommen (keine echte Buchung).
    var picker = root.querySelector('[data-jbv-picker]');
    if (picker) {
      var daysBox = picker.querySelector('[data-jbv-days]'), timesBox = picker.querySelector('[data-jbv-times]');
      var slotInput = root.querySelector('[data-jbv-slot]');
      var closed = ['01-01','05-01','10-03','12-24','12-25','12-26','12-31','2027-03-26','2027-03-29','2027-05-06','2027-05-17','2027-05-27'];
      var wd = ['So','Mo','Di','Mi','Do','Fr','Sa'];
      var chosenDay = null, chosenTime = '';
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function isClosed(d) {
        var md = pad(d.getMonth() + 1) + '-' + pad(d.getDate());
        return d.getDay() === 0 || closed.indexOf(md) > -1 || closed.indexOf(d.getFullYear() + '-' + md) > -1;
      }
      function writeSlot() {
        if (!slotInput) return;
        slotInput.value = chosenDay ? wd[chosenDay.getDay()] + ', ' + pad(chosenDay.getDate()) + '.' + pad(chosenDay.getMonth() + 1) + '.' + chosenDay.getFullYear() + (chosenTime ? ', ' + chosenTime + ' Uhr' : '') : '';
      }
      function renderTimes() {
        timesBox.innerHTML = '';
        if (!chosenDay) return;
        var last = chosenDay.getDay() === 6 ? 16 : 17, now = new Date();
        var today = chosenDay.toDateString() === now.toDateString();
        for (var h = 10; h <= last; h++) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'jbv-time'; b.textContent = pad(h) + ':00';
          b.setAttribute('aria-pressed', String(chosenTime === b.textContent));
          if (today && h <= now.getHours() + 1) b.disabled = true;
          b.addEventListener('click', function () {
            chosenTime = this.textContent;
            timesBox.querySelectorAll('.jbv-time').forEach(function (x) { x.setAttribute('aria-pressed', String(x.textContent === chosenTime)); });
            writeSlot();
          });
          timesBox.appendChild(b);
        }
      }
      var d = new Date(); d.setHours(12, 0, 0, 0);
      var added = 0;
      while (added < 14) {
        if (!isClosed(d) && !(d.toDateString() === new Date().toDateString() && new Date().getHours() >= 16)) {
          (function (day) {
            var b = document.createElement('button');
            b.type = 'button'; b.className = 'jbv-day'; b.setAttribute('aria-pressed', 'false');
            b.innerHTML = '<small>' + wd[day.getDay()] + '</small>' + pad(day.getDate()) + '.' + pad(day.getMonth() + 1) + '.';
            b.addEventListener('click', function () {
              chosenDay = day; chosenTime = '';
              daysBox.querySelectorAll('.jbv-day').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
              renderTimes(); writeSlot();
            });
            daysBox.appendChild(b);
          })(new Date(d));
          added++;
        }
        d.setDate(d.getDate() + 1);
      }
    }

    // 10-%-Vorteil: Klick im Popup vermerkt den Code in der Anfrage.
    function applyVoucher() {
      var vi = root.querySelector('[data-jbv-voucher-input]'), vn = root.querySelector('[data-jbv-voucher-note]');
      if (vi) vi.disabled = false;
      if (vn) vn.hidden = false;
    }
    try { if (sessionStorage.getItem('jbv_voucher') === '1') applyVoucher(); } catch (err) {}
    root.querySelectorAll('[data-jbv-voucher]').forEach(function (el) {
      el.addEventListener('click', function () { try { sessionStorage.setItem('jbv_voucher', '1'); } catch (err) {} applyVoucher(); });
    });

    var raster = document.querySelector('[id$="__collection-body"]');
    if (raster && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (eintraege) { document.body.classList.toggle('jbv-raster-sichtbar', eintraege[0].isIntersecting); }).observe(raster);
    } else { document.body.classList.add('jbv-raster-sichtbar'); }

    var pop = root.querySelector('[data-jbv-pop]');
    if (pop && root.closest('body')) {
      var seen = false;
      try { seen = sessionStorage.getItem('jbv_pop_seen') === '1'; } catch (err) {}
      var opened = false;
      function close() { pop.hidden = true; try { sessionStorage.setItem('jbv_pop_seen', '1'); } catch (err) {} }
      function open() {
        if (opened || seen) return;
        var formular = root.querySelector('form');
        if (formular) { var fr = formular.getBoundingClientRect(); if (fr.top < innerHeight && fr.bottom > 0) return; }
        var active = document.activeElement;
        if (active && root.querySelector('form') && root.querySelector('form').contains(active)) return;
        opened = true; pop.hidden = false;
        var c = pop.querySelector('[data-jbv-pop-close]'); if (c) c.focus();
      }
      if (!seen && !(window.Shopify && window.Shopify.designMode)) {
        // 22.10.2026: kein Zeit-Ausloeser mehr; Popup nur ab 85 % Scrolltiefe und nie, solange das Terminformular im Bild ist.
        window.addEventListener('scroll', function onScroll() {
          var max = document.documentElement.scrollHeight - innerHeight;
          if (max > 0 && scrollY / max > 0.85) { open(); if (opened) window.removeEventListener('scroll', onScroll); }
        }, { passive: true });
      }
      pop.addEventListener('click', function (e) { if (e.target === pop || e.target.closest('[data-jbv-pop-close]') || e.target.closest('[data-jbv-pop-action]')) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
    }
  }
  document.querySelectorAll('[data-jbv]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-jbv]').forEach(init); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
(() => {
  const observed = new WeakSet();
  const attach = () => document.querySelectorAll('.js-slideshow').forEach(slider => {
    if (observed.has(slider)) return;
    observed.add(slider);
    const normalize = () => slider.querySelectorAll('.swiper-slide-duplicate h1.slideshow__slide-heading').forEach(heading => {
      const replacement = document.createElement('h2');
      for (const attribute of heading.attributes) replacement.setAttribute(attribute.name, attribute.value);
      replacement.append(...heading.childNodes);
      heading.replaceWith(replacement);
    });
    normalize();
    new MutationObserver(normalize).observe(slider, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach, { once: true });
  else attach();
  document.addEventListener('shopify:section:load', attach);
})();

  } catch(e) { console.error(e); }
})();
})();
